<script lang="ts">
    import { onMount } from 'svelte'
    import Fa from 'svelte-fa'
    import { faCopy } from '@fortawesome/free-solid-svg-icons'
    import type { Profile } from '../../modules/toolsApi/sites/profiles/profile'
    import type { Schedule } from '../../modules/schedulerApi/schedules/schedule'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import Zgrid from '../_common/z/zgrid.svelte'

    let loaded = false
    onMount(async () => {
        await loadLinks()
        loaded = true
    })

    let links: { label: String; url: string; active: boolean }[] = []
    let profile: Profile = null
    async function loadLinks() {
        console.log('uai')
        links = []
        let url = ''
        profile = await window.api.tools.sites.profiles.getOne(window.store.company.companyId)
        if (profile?.slug) {
            if (location.href.includes('127.0.0') || location.href.includes('localhost')) {
                url = 'http://localhost:5173/' + profile.slug + '/scheduler'
            } else {
                url = 'https://agenda.zandu.com.br/' + profile.slug + '/scheduler'
            }
            links.push({
                label: 'Todas as agendas',
                url: url,
                active: true,
            })
            const schedules: Schedule[] = await window.api.schedulers.schedules.getAll({ all: true })
            for (const schedule of schedules) {
                if (schedule.public) {
                    links.push({
                        label: schedule.label,
                        url: url + '/?s=' + schedule.scheduleId,
                        active: true,
                    })
                } else {
                    links.push({
                        label: schedule.label,
                        url: '[agenda com agendamento online desativado]',
                        active: false,
                    })
                }
            }
            links = links
            loadGrid()
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Links das Agendas'
        grid.subtitle = ''
        grid.showActs = false
        grid.cols.push(new GridCol({ content: 'Agenda' }))
        grid.cols.push(new GridCol({ content: 'Link' }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of links) {
            const btnCopy = new GridButton({
                callback: () => copyLink(item.url),
                icon: faCopy,
                label: 'Copiar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.label })
            line.slots.push({ content: item.url })
            if (item.active) {
                line.slots.push({ content: [btnCopy] })
            } else {
                line.slots.push({ content: [] })
            }
            grid.lines.push(line)
        }
    }

    function copyLink(url) {
        window.api.utils.utils.copyToClipboard(url)
        window.alert('Link copiado')
    }
</script>

{#if loaded}
    <div class="root m-3">
        {#if !profile}
            <div class="config-box text-center">
                Você ainda não configurou seu aplicativo.<br />
                Para configurar acesse o menu 'Ferramentas &gt; Meu Aplicativo'
            </div>
        {:else}
            <Zgrid {grid} />
            <div class="config-box mt-2 text-muted">
                Dica: Quer enviar um link para uma pessoa específica?<br />
                Abra o perfil da pessoa e copie o link de lá. Assim ele não precisará fazer login para agendar.
            </div>
        {/if}
    </div>
{/if}

<style>
</style>
